"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _useSetupWidget = require("../hooks/app/useSetupWidget");
var _useUserSessionStatus2 = require("../hooks/user/useUserSessionStatus");
var _GuidedSellingModal = _interopRequireDefault(require("./GuidedSellingModal"));
var _CTAentryPoints = _interopRequireDefault(require("./CTAentryPoints"));
var _BaseComponents = require("./StyledComponents/BaseComponents");
var _useUserSessionState = require("../hooks/user/useUserSessionState");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var App = function App(_ref) {
  var instanceId = _ref.instanceId;
  (0, _useSetupWidget.useSetupWidget)(instanceId);
  var _useUserSessionStatus = (0, _useUserSessionStatus2.useUserSessionStatus)(),
    isUserSessionLoaded = _useUserSessionStatus.isUserSessionLoaded;
  (0, _useUserSessionState.useUserSessionState)();
  if (!isUserSessionLoaded) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement(_BaseComponents.StyledGuidedSellingWrapper, {
    className: "gs-app"
  }, /*#__PURE__*/_react.default.createElement(_CTAentryPoints.default, null), /*#__PURE__*/_react.default.createElement(_GuidedSellingModal.default, null));
};
var _default = App;
exports.default = _default;